import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class FinishPagePath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/finish';
  }
}
